const AUTH_URL = process.env.REACT_APP_BASE_URL;

export const ApiPath = {
  auth: `${AUTH_URL}`,
};
